
// Type for leaderboard entry
export interface LeaderboardEntry {
  id: string;
  name: string;
  points: number;
  streak: number;
  avatar?: string;
  zones?: { [key: string]: number };
}

// Define zone type
export interface Zone {
  id: string;
  name: string;
  icon: any; // Using any for Lucide icon component type
  color: string;
}

// Define zones
export const zones: Zone[] = [
  { id: 'exercise', name: 'Exercise', icon: 'Award', color: 'bg-purple-100 text-purple-700' },
  { id: 'nutrition', name: 'Nutrition', icon: 'Leaf', color: 'bg-green-100 text-green-700' },
  { id: 'hydration', name: 'Hydration', icon: 'Droplets', color: 'bg-blue-100 text-blue-700' },
  { id: 'prescriptions', name: 'Prescriptions and Supplements', icon: 'Pill', color: 'bg-pink-100 text-pink-700' },
  { id: 'sleep', name: 'Sleep', icon: 'Moon', color: 'bg-indigo-100 text-indigo-700' },
  { id: 'mindfulness', name: 'Mindfulness', icon: 'Brain', color: 'bg-amber-100 text-amber-700' },
  { id: 'social', name: 'Social', icon: 'Users', color: 'bg-red-100 text-red-700' },
];
